export function nowBogota(): Date {
    const now = new Date()
    const bogotaString = now.toLocaleString('en-US', { timeZone: 'America/Bogota' })
    return new Date(bogotaString)
}

export function parseDateBogota(dateString: string, startOfDay = true): Date {
    const [year, month, day] = dateString.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))

    const offset = -5 * 60
    date.setUTCMinutes(date.getUTCMinutes() + offset)

    if (startOfDay) {
        date.setHours(0, 0, 0, 0)
    } else {
        date.setHours(23, 59, 59, 999)
    }

    return date
}

export function formatDateYYYYMMDD(date: Date): string {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}


export function formatToMMDD(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${month}-${day}`
}


export const formatDate = (dateString: string): string => {
    const date = new Date(dateString)

    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Bogota'
    }

    const formatter = new Intl.DateTimeFormat('es-CO', options)
    const parts = formatter.formatToParts(date)

    const day = parts.find(p => p.type === 'day')?.value
    const month = parts.find(p => p.type === 'month')?.value
    const hour = parts.find(p => p.type === 'hour')?.value
    const minute = parts.find(p => p.type === 'minute')?.value

    return `${day} de ${month} a las ${hour}:${minute}`
}
